import React, {useEffect, useContext, useState} from "react";
import QueryString from "query-string";
import {Redirect} from "react-router-dom";
import { ShopContext } from "../../../context/ShopContext"
import { CatalogueContext } from "../../../context/CatalogueContext"
import {LoadingScreen, ErrorScreen, Scaffolding} from "../../shared";
import {Button} from "../../controls";


function FinalizePayment(props) {
  // context
  const SC = useContext(ShopContext);
  const CC = useContext(CatalogueContext)
  // state
  const [redirectTo, setRedirectTo] = useState(null);
  const [paymentFailed, setPaymentFailed] = useState(false);

  // mount
  useEffect(() => {
    if(CC.isReady) {
      finalize();
    }
  }, [CC.isReady]);

  /**
   * attempts to finalize the payment
   */
  const finalize = async() => {
    // read query string (we get this from payrexx ... in cart.initializePayrexx() we setup the query parameter to by 'payment' and return either 'success', 'cancel', or 'failed')
    const queryValues = QueryString.parse(props.location.search);
    const paymentResult = (queryValues["payment"] || "").toLowerCase();

    // payrexx says "cancel" - abort and redirect to checkout/confirm
    if(paymentResult === "cancel") {
      setRedirectTo("/checkout/confirm");
      return;
    }

    // payrexx says "failed"
    if(paymentResult === "failed") {
      setPaymentFailed(true);
      return;
    }

    // payrexx says "success" - make sure if the payment was actually succesful
    if(paymentResult === "success") {
      const result = await SC.cart.finalizePayrexx();
      if(result.success) {
        setRedirectTo("/checkout/done");
        return;
      }
      else {
        setPaymentFailed(true);
        return;
      }
    }

    // any other case redirect to checkout/confirm
    setPaymentFailed(true);
  }

  // user clicks retry after error
  const onClickBack = () => {
    setRedirectTo("/checkout/confirm");
  }

  // success ... redirect to the done page
  if(redirectTo) {
    return <Redirect to={redirectTo} />
  }
  
  // render
  let content = <LoadingScreen mode="finalizePayment" />
  if(paymentFailed) {
    content = (
      <Scaffolding>
        <ErrorScreen 
          title="Zahlung fehlgeschlagen" 
          buttonTitle="zurück zum Warenkorb"
          onButtonClick={onClickBack}
        >
          <p>Leider konnte die Zahlung nicht abgeschossen werden.</p>
          <p>Du darfst gerne mit uns Kontakt aufnehmen oder es nochmals versuchen.</p>
        </ErrorScreen>
      </Scaffolding>
    )
  }
  return <>
    {content}
  </>
}

export default FinalizePayment;
